<template>
  <b-tab-item :label="label" :value="value" @input="$emit('input', $event)">
    <slot></slot>
  </b-tab-item>
</template>

<script>
export default {
  name: "TabsTab",
  props: {
    label: {
      type: String,
      required: true,
    },

    value: {
      type: String,
      required: false,
    },
  },
}
</script>

<style scoped>

</style>
